import Settings from 'modules/User/Settings/Settings'

export default Settings
